import styled from "styled-components";
import { background, border, color, flexbox, layout, position, shadow, space, typography, opacity } from "styled-system";

export const Box: any = styled.div(background, space, layout, flexbox, color, typography, border, position, shadow, opacity);
